import MessageGenericView from "./message.generic.view";
import Template from 'js/templates/message.sms.hbs';
import GenericView from 'js/views/message.generic.view';
import i18n from 'l10n';
import {el, handles, on, template} from "js/adapters/backbone-decorators";
import {_, Backbone} from "backboneAdapter";

import {Range} from "range";

require('metroHint2');
require('ace');

@template(Template)
@el("#edit-sms-message")
class MessageSMSView extends MessageGenericView {

    constructor(options) {
        super(options);
        this.SMScount = 1;
        this.charactersCount = 0;
        this.areCreditsEnough = true;
        this.isMessageSaved = true;
        this.errors = [];
        this.isSms = true;

        $.ajaxDefaultQ({
            url: '/CampaignCloud/CustomFields'
        }).done(response => {
            this.model.set("customFields", response);
            // this.superInitialize(options);
        }).fail(response => {
            console.error(response);
        });
    }

    render() {
        super.render();
        this.$("#messages-count").text(this.SMScount);
        this.$("#messages-count2").text(this.SMScount2);
        this.$("#editor").text(this.model.get("message"));

        if (this.$("#editor2")) {
            this.$("#editor2").text(this.model.get("successMessage"));
        }
        this.setupEditor("editor", "");
        if (this.model.get("campaignTemplateType") === "SMART_NOTIFICATION") this.setupEditor("editor2", "2");
        this.checkForTrialAccount();
        return this;
    }

    setupEditor(editor, idSuffix) {
        if (!$(`#editor${idSuffix}`).length) {
            return;
        }
        this[editor] = window.ace.edit("editor" + idSuffix);
        this[editor].setTheme("ace/theme/chrome");
        this[editor].getSession().setMode("ace/mode/custom");
        this[editor].getSession().setUseWrapMode(true);
        this[editor].setOption("showPrintMargin", false);
        this[editor].$blockScrolling = Infinity;
        this[editor].getSession().on("updateTokenizer", () => {
            this.keypress(false, idSuffix);
        }); // Custom updateTokenizer event handling to count correctly
        this.editor.setFontSize(20);
        this.editor.on('input', () => {
            $("#editor-tile").removeClass("bd-lightBlue").addClass("bd-lightRed");
            this.isMessageSaved = false;
        });
        this.editor.on('paste', function (o) {
            o.text = o.text.replace(/\r/g, '');
        });
        if (this.model.get("campaignId") > 0) {
            this[editor].setReadOnly(true);
        }
    }


    @on("click #message-save")
    clickMsgSave() {
        this.messageSave("message", "");
    }

    @on("click #message-save2")
    clickMsgSave2() {
        this.messageSave("successMessage", "2");
    }

    @on("click #message-cancel")
    clickMsgCancel() {
        this.messageCancel("message", "");
    }

    @on("click #message-cancel2")
    clickMsgCancel2() {
        this.messageCancel("successMessage", "2");
    }

    @on("focus #editor-tile")
    focusEdtr() {
        this.showMessageButtons("");
    }

    @on("focus #editor-tile .brand")
    focusBrand() {
        this.showMessageButtons("");
    }

    @on("focus #editor-tile2")
    focusEdtr2() {
        this.showMessageButtons("2");
    }

    @on("focus #editor-tile2 .brand")
    focusEdtr2Brand() {
        this.showMessageButtons("2");
    }

    @on("keyup #editor")
    keyUpEdtr() {
        this.keypress(true, "");
    }

    @on("keyup #editor2")
    keyUpEdtr2() {
        this.keypress(true, "2");
    }

    @on("click #message-voucher")
    @on("click #message-tags")
    @on("click #message-optout")
    @on("click #message-profileUpdate")
    @on("click #message-link")
    @on("click #message-file")
    @on("click #message-survey")
    magicTags(event) {
        var elem = $(event.currentTarget);
        var tagName = elem.attr("id").split("-")[1];
        var text = "";
        switch (tagName) {
            case "voucher":
                if (this.allowAdvancedServices())
                    text = "{UURL.voucher}";
                break;
            case "optout":
                text = "{UURL.optout}";
                break;
            case "profileUpdate":
                text = "{profileHash}";
                break;
            case "link":
                text = "{UURL.url}";
                break;
            case "file":
                text = "{UURL.download}";
                break;
            case "survey":
                if (this.allowAdvancedServices())
                    text = "{UURL.survey}";
                break;
        }
        var pos = this.editor.getCursorPosition();
        var r, prevChar;
        if (pos.column) {
            r = new Range(pos.row, pos.column - 1, pos.row, pos.column);
            prevChar = this.editor.session.getTextRange(r);
            if (prevChar && prevChar !== '\t') {
                text = ` ${text}`;
            }
        }
        {
            r = new Range(pos.row, pos.column, pos.row, pos.column + 1);
            prevChar = this.editor.session.getTextRange(r);
            if (prevChar && prevChar !== '\t') {
                text = `${text} `;
            }
        }
        this.editor.insert(text);
        this.editor.focus();
        setTimeout(function () {
            $('.ace_text-input')[0].style.top = "0px";
        }, 50);
    }

    @on("click .message-tag")
    magicTag(event) {
        var elem = $(event.currentTarget);
        var tagName = elem.data("value");
        var text = "";
        switch (tagName) {
            case "message-tags":
                break;
            case "firstname":
                text = "{subscriber.name}";
                break;
            case "firstname_voc":
                text = "{subscriber.name_voc}";
                break;
            case "lastname":
                text = "{subscriber.surname}";
                break;
            case "lastname_voc":
                text = "{subscriber.surname_voc}";
                break;
            case "address":
                text = "{subscriber.address}";
                break;
            case "profession":
                text = "{subscriber.profession}";
                break;
            case "cf1":
                text = "{customfield1}";
                break;
            case "cf2":
                text = "{customfield2}";
                break;
            case "cf3":
                text = "{customfield3}";
                break;
            case "cf4":
                text = "{customfield4}";
                break;
            case "cf5":
                text = "{customfield5}";
                break;
            case "cf6":
                text = "{customfield6}";
                break;
            case "cf7":
                text = "{customfield7}";
                break;
            case "cf8":
                text = "{customfield8}";
                break;
            case "cf9":
                text = "{customfield9}";
                break;
            case "cf10":
                text = "{customfield10}";
                break;
        }
        this.editor.insert(text);
        this.editor.focus();
        setTimeout(function () {
            $('.ace_text-input')[0].style.top = "0px";
        }, 50);
    }

    @on("click #message-gender-tags")
    @on("click .message-gender-tag")
    magicGenderTag(event) {
        var self = this;
        var elem = $(event.currentTarget);
        var tagName = elem.data("value");
        var text = "";
        switch (tagName) {
            case "gender-tags":
                break;
            case "genderMale":
                text = `[M[ ${self.i18n.t("subscriber.genderDefault")} ]]`;
                break;
            case "genderFemale":
                text = `[F[ ${self.i18n.t("subscriber.genderDefault")} ]]`;
                break;
            case "genderOther":
                text = `[O[ ${self.i18n.t("subscriber.genderDefault")} ]]`;
                break;
            case "genderNone":
                text = `[N[ ${self.i18n.t("subscriber.genderDefault")} ]]`;
                break;
        }
        this.editor.insert(text);
        this.editor.focus();
        setTimeout(function () {
            $('.ace_text-input')[0].style.top = "0px";
        }, 50);
    }

    magicGenderTags() {
    }

    keypress(real, idSuffix) {
        this.isMessageSaved = false;
        this.isTriggeredByKeyPress = true;
        var tokens = [];
        var totalRows = this["editor" + idSuffix].session.getLength();
        var counts = [0, 0, 0, 0];
        var curr = -1;
        var inc = function (n) {
            if (curr === -1) {
                counts[0] += n;
                counts[1] += n;
                counts[2] += n;
                counts[3] += n;
            } else {
                counts[curr] += n;
            }
        };
        var approximate = false;
        var urlTemplateLength = "https://NNNN.tellody.com/u/".length + 5;
        if (real)
            this.$('#editor-tile button' + idSuffix).css("visibility", 'visible');
        for (var i = 0; i < totalRows; i++) {
            var token = this["editor" + idSuffix].session.getTokens(i);
            for (var j = 0; j < token.length; j++) {
                var tokenValue = token[j].value;
                if (token[j].type === "bracket") {
                    while (tokenValue.length > 0) {
                        if (tokenValue.startsWith("[M[")) {
                            if (curr === -1) curr = 0;
                            tokenValue = tokenValue.substring(3);
                        } else if (tokenValue.startsWith("[F[")) {
                            if (curr === -1) curr = 1;
                            tokenValue = tokenValue.substring(3);
                        } else if (tokenValue.startsWith("[O[")) {
                            if (curr === -1) curr = 2;
                            tokenValue = tokenValue.substring(3);
                        } else if (tokenValue.startsWith("[N[")) {
                            if (curr === -1) curr = 3;
                            tokenValue = tokenValue.substring(3);
                        } else { // "]]"
                            curr = -1;
                            tokenValue = tokenValue.substring(2);
                        }
                    }
                } else if (token[j].type === "text") {
                    tokenValue = this.capitalizeGreek(token[j].value);
                    inc(tokenValue.length);
                } else if (token[j].type === "double")
                    inc(tokenValue.length * 2);
                else if (token[j].type === "tag") {
                    var parts = tokenValue.split(/[{}]/);
                    parts = parts.filter(function (s) {
                        return s !== "";
                    });
                    for (var k = 0; k < parts.length; k++) {
                        var part = parts[k];
                        if (part === "UURL.url") {
                            inc(urlTemplateLength);
                        } else if (part === "UURL.urlcode") {
                            inc(5);
                        } else if (part === "UURL.voucher") {
                            inc(urlTemplateLength);
                        } else if (part === "UURL.vouchercode") {
                            inc(5);
                        } else if (part === "woo.coupon") {
                            inc(urlTemplateLength);
                        } else if (part === "woo.couponcode") {
                            inc(5);
                        } else if (part === "UURL.survey") {
                            inc(urlTemplateLength);
                        } else if (part === "UURL.download") {
                            inc(urlTemplateLength);
                        } else if (part === "UURL.optout") {
                            inc(urlTemplateLength);
                        } else if (part === "profileHash") {
                            inc(61);
                        } else if (part === "subscriber.name") {
                            inc(20);
                        } else if (part.startsWith("subscriber.name:")) {
                            inc(20);
                        } else if (part === "subscriber.name_voc") {
                            inc(20);
                        } else if (part.startsWith("subscriber.name_voc:")) {
                            inc(20);
                        } else if (part === "subscriber.surname") {
                            inc(35);
                        } else if (part.startsWith("subscriber.surname:")) {
                            inc(35);
                        } else if (part === "subscriber.surname_voc") {
                            inc(35);
                        } else if (part.startsWith("subscriber.surname_voc:")) {
                            inc(35);
                        } else if (part.startsWith("cf")) {
                            inc(60);
                        } else if (part.startsWith("config")) {
                            inc(40); //todo arbitrary medium-sized estimate
                            approximate = true;
                        } else if (part.startsWith("event")) {
                            inc(40); //todo arbitrary medium-sized estimate
                            approximate = true;
                        } else {
                            console.info(part + "unknown UURL O.O");
                        }
                    }
                } else {
                    console.info("not known type :O");
                }
            }
            tokens = tokens.concat(token);
        }
        inc(totalRows - 1);

        var count = Math.max(counts[0], Math.max(counts[1], Math.max(counts[2], counts[3])));

        var messageText = this.capitalizeGreek(this["editor" + idSuffix].session.getValue());
        this["charactersCount" + idSuffix] = count;
        this["approximate"] = approximate;
        this["SMScount" + idSuffix] = (count > 160 ? Math.ceil(parseInt(count) / 153) : 1);
        this.$("#characters-count" + idSuffix).text((approximate ? "~" : "") + count);
        this.$("#total-characters" + idSuffix).text((count > 160 ? this["SMScount" + idSuffix] * 153 : 160));
        this.$("#messages-count" + idSuffix).text(this["SMScount" + idSuffix]);

        this.isTriggeredByKeyPress = false;
    }

    capitalizeGreek(string) {
        var regexText = "[α-ωΐάέήίΰϊϋόύώ]"; //greek lowercase letters

        var regex = new RegExp(regexText);

        var res = null;
        while (regex.test(string)) {
            res = regex.exec(string);

            if (res) {
                string = string.replace(res[0], res[0].toUpperCase());
            }
        }
        return string;
    }

    @handles("selected:triggeredEvent")
    @handles("opened:EditingSelectingContent")
    validateMessageCondition() {
        this.errors = [];

        var urlValidation = this.validateUrl();
        if (urlValidation && !$("#url-editable").find("form").length) //do not show the error, while the element is currently getting edited
            this.errors.push(urlValidation);

        var contentValidation = this.validateContent();
        if (contentValidation && $($("#select-file-content").find(".heading")[0]).hasClass("collapsed"))  //do not show the error, while the element is currently getting edited
            this.errors.push(contentValidation);

        var voucherValidation = this.validateVoucher();
        if (voucherValidation && $($("#voucher-options").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited
            this.errors.push(voucherValidation);

        var surveyValidation = this.validateSurvey();
        if (surveyValidation && $($("#survey-options").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited
            this.errors.push(surveyValidation);

        if (this.campaignView) {
            var campaignValidation = this.validateCampaign();
            if (campaignValidation && $($("#triggering-event").find(".heading")[0]).hasClass("collapsed")) //do not show the error, while the element is currently getting edited
                this.errors.push(campaignValidation);
        }

        this.validateSmsLongWords(); //it will "push" all words' errors directly into the `errors` array

        this.validateGSMChars();

        this.updateMessageCount();

        var messageSavedCheck = this.validateMessageSaved();
        if (messageSavedCheck) {
            this.errors.push(messageSavedCheck);
        }

        if (!this.charactersCount) {
            this.errors.push({
                "type": i18n.t("message.error"),
                "description": i18n.t("message.emptyField"),
                "value": i18n.t("message.emptyMessageContent")
            });
        }

        if (!this.targetingSize && this.model.get("campaignTemplateType") !== "SMART_NOTIFICATION"
            && this.model.get("description") !== "birthday" && this.model.get("description") !== "nameday") {
            this.errors.push({
                "type": i18n.t("message.error"),
                "description": i18n.t("message.selecttargetingtitle"),
                "value": i18n.t("message.messagenocontactsselectedoravailable")
            });
        }

        this.updateGraph();

        if (this.errors.length > 0)
            this.showErrors(this.errors);
        else
            this.hideErrors();

        if (this.userModel.get("postpaid")) {
            if (!this.isContentValid || !this.isUrlValid || !this.isVoucherValid || !this.isSurveyValid || !this.isCampaignValid ||
                !this.charactersCount || !this.isMessageSaved || this.smsWordsTooLong || this.nonGSMChars) {
                this.$("#execute-send").removeClass("bg-white bg-hover-white fg-green fg-hover-emerald ol-green")
                    .addClass("bg-white bg-hover-white ol-red fg-orange fg-hover-red cursor-not-allowed");
                this.toggleExecuteButton(false);
                return false;
            } else {
                this.$("#execute-send").removeClass("bg-white bg-hover-white ol-red fg-orange fg-hover-red cursor-not-allowed")
                    .addClass("bg-white bg-hover-white fg-green fg-hover-emerald ol-green");
                this.toggleExecuteButton(true);
                return true;
            }
        } else {
            return this.checkAndActivateExecuteButton();
        }
    }

    @handles("calculated:campaignCost")
    checkAndActivateExecuteButton() {
        if (!this.isContentValid || !this.isUrlValid || !this.isVoucherValid || !this.isSurveyValid ||
            !this.isCampaignValid || !this.charactersCount || !this.isMessageSaved ||
            (this.model.get("description") !== "tellody-event" && !this.areCreditsEnough) || this.smsWordsTooLong || this.nonGSMChars) {
            this.toggleExecuteButton(false);
            return false;
        } else {
            this.toggleExecuteButton(true);
            return true;
        }
    }

    showMessageOfUsableContacts(self, data) {
        if (data[0] !== data[2]) {
            $.Notify.show(self.i18n.t("message.usablecontacts", {count: (data[2] - data[0])}));
        }
    }

    execute() {
        var callback = function (visibility) {
            var $editor = $("#editor-tile button");
            return $editor.css("visibility", visibility);
        };
        var callback1 = function () {
            return callback('visible');
        };
        var callback2 = function () {
            return callback('hidden');
        };
        super.execute("SMS", "message.confirmsmssendtitle", this.editor.getValue(), callback1, callback2);
    }

    showMessageButtons(idSuffix) {
        $(`#editor-tile${idSuffix} button`).css("visibility", 'visible');
    }

    hideMessageButtons(idSuffix) {
        $(`#editor-tile${idSuffix} button`).css("visibility", 'hidden');
    }

    messageSave(attr, idSuffix) {
        var value = this[`editor${idSuffix}`].getValue();
        //self.model.set(attr, value); //set the new value to the model, so the validation will check the correct one
        this.model.saveAttribute(attr, value, (attributeName, value1, outcome) => {
            $.Notify.show(this.i18n.t("generic.attributechanged", {
                attributeName: attributeName,
                value: value,
                outcome: this.i18n.t(`generic.=${outcome}`)
            }));
            if ("OK" !== outcome) {

                this.render();
                this.isMessageSaved = false;
            } else {
                $(`#editor-tile${idSuffix} button`).css("visibility", 'hidden');
                this.isMessageSaved = true;
                $(`#editor-tile${idSuffix}`).removeClass("bd-lightRed").addClass("bd-lightBlue");
                this.cleanUnusedUurlOptions(value);
                if (this.model.get("description") === "tellody-event")
                    this.getDependenciesSmsCount();
            }
            this.validateMessageCondition();
        });
    }

    messageCancel(attr, idSuffix) {
        var self = this;
        var v = self.model.get(attr);
        this[`editor${idSuffix}`].setValue(v);
        $(`#editor-tile${idSuffix} button`).css("visibility", 'hidden');
        /*
        * Update the charactersCount because when cancel is pressed unsaved content is discarded.
        * When you press the button in the first time without that assignment the validation
        * of characters count will pass because it is checked against the previous entered message
        * content.
        */
        self.charactersCount = v.length;
        $("#characters-count").text((self.approximate ? "~" : "") + self.charactersCount);
        self.validateMessageCondition();
    }

    superValidateVoucher() {
        GenericView.prototype.validateService.call(this, "voucher");
    }

    validateVoucher() {
        var self = this;
        return self.superValidateVoucher();
    }

    superValidateSurvey() {
        GenericView.prototype.validateService.call(this, "survey");
    }

    validateSurvey() {
        var self = this;
        return self.superValidateSurvey();
    }


    validateMessageSaved() {
        var self = this;
        if (this.editor) {
            if ($("#editor-tile button").css("visibility") === 'visible') {
                self.isMessageSaved = false;
                return {
                    "type": i18n.t("message.error"),
                    "description": i18n.t("message.nonSavedMessageContent"),
                    "value": i18n.t('message.warningsaveordiscard')
                };
            } else {
                self.isMessageSaved = true;
                return null;
            }
        }
        return null;
    }

    @on("click #buy-credits")
    buyCredits() {
        var self = this;
        var value = this.editor.getValue();
        var attr = "message";
        if (!self.isMessageSaved) {
            self.model.saveAttribute(attr, value, function (attributeName, value1, outcome) {
                $.Notify.show(self.i18n.t("generic.attributechanged", {
                    attributeName: attributeName,
                    value: value,
                    outcome: self.i18n.t("generic.=" + outcome)
                }));
                if ("OK" !== outcome) {
                    self.render();
                } else {
                    location.href = `./Credits.htm?messageId=${self.model.id}`;
                }
            });
        } else {
            location.href = `./Credits.htm?messageId=${self.model.id}`;
        }
    }

    validateOriginator(e, el, ev) {
        var self = this;
        var $sender = $('#sender-name-error-message');
        $sender.hide();
        if (e.val().length === 11 && !(ev.which === 8 || ev.which === 13)) {
            $sender.show();
            $sender.text(self.i18n.t("message.sendernameerror"));
            ev.preventDefault();
            return;
        }
        if (!((ev.which > 47 && ev.which < 58) ||
            (ev.which > 64 && ev.which < 91) ||
            (ev.which > 96 && ev.which < 123) ||
            ev.which === 8 ||
            ev.which === 13)) {
            $sender.show();
            $sender.text(self.i18n.t("message.sendernameerror"));
            ev.preventDefault();
        }
    }

    clearErrorMessage() {
        $('#sender-name-error-message').hide();
    }

    updateMessageCount() {
        GenericView.prototype.updateMessageCount.call(this, {});
    }

    validateSmsLongWords() {
        var self = this;
        var textContent = this.editor.getValue();
        var smsCharacterCount = 160;

        var words = textContent.split(/(\s+|\\n)/).filter(function (n) {
            return n.trim();
        });
        var hasError = false;

        _.each(words, function (word) {
            if (word.length > smsCharacterCount) {
                if (word.startsWith("http://") || word.startsWith("https://")) {
                    self.errors.push({
                        "description": `${i18n.t("message.tooLongUrl")} ${i18n.t("message.useSmallerUrl")}`,
                        "value": word,
                        "type": i18n.t("message.error")
                    });
                } else {
                    self.errors.push({
                        "description": i18n.t("message.tooLongWord"),
                        "value": word,
                        "type": i18n.t("message.error")
                    });
                }
                hasError = true;
            }
        });
        this.smsWordsTooLong = hasError;
    }

    validateGSMChars() {
        var self = this;
        var textContent = this.editor.getValue();
        var hasError = false;
        for (var c of textContent) {
            if (("@£$¥èéùìòÇ\nØø\rÅå_ÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡" +
                "ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñ" +
                "üà\f^{}\\[~]|€ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩΆΈΉΊΪΌΎΫΏαβγδεζηθικλμνξοπρσςτυφχψωάήέίόύώϊΐϋΰ").indexOf(c) == -1) {
                self.errors.push({
                    "description": i18n.t("message.nonGSMChar"),
                    "value": c,
                    "type": i18n.t("message.error")
                });
                hasError = true;
            }
        }
        self.nonGSMChars = hasError;
    }
}

export default MessageSMSView;
